module.exports = __webpack_public_path__ + "static/img/logo-kln.7c134ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-kln.png
// module id = bjw4
// module chunks = 1